import React from 'react';
import PropTypes from 'prop-types';
import { VariableSizeList as List } from 'react-window';
import $ from 'jquery';

const menuListRef = React.createRef();

const SelectVirtualMenuList = ({
  options,
  children,
  getValue,
  selectProps,
}) => {
  let noOptions = false;
  let nChildren = children;
  if (nChildren instanceof Object && nChildren.constructor === Object) {
    nChildren = [nChildren];
    if (options.length === 0) {
      options.push({});
    }
    noOptions = true;
  }

  const updateDropdownWidth = () => {
    const el = $(`#${selectProps.id}`);

    let elClass = '';
    let elSelector = '';

    if (el.hasClass('user-select')) {
      elClass = '.user-select__menu';
      elSelector = `${elClass} .user-item`;
    }
    if (el.hasClass('filter-select')) {
      elClass = '.filter-select__menu';
      elSelector = `${elClass} .filter-terms-select-item`;
    }

    if (noOptions) {
      el.find(`${elClass} > div > div`).width($(elClass).width());
      return;
    }

    const width = el.find(`${elClass} > div`).width();

    let maxWidth = 0;
    el.find(elSelector).each((idx, item) => {
      maxWidth = Math.max(maxWidth, $(item).get(0).scrollWidth);
    });

    const targetWidth = Math.max(maxWidth, width);
    if (maxWidth <= width) {
      el.find(`${elClass} > div`).css('overflow-x', 'hidden');
    } else {
      el.find(`${elClass} > div`).css('overflow-x', 'auto');
    }

    el.find(`${elClass} > div > div`).width(targetWidth);
  };

  const highLists = [
    'shareInviteUsers',
    'accessAddGroup',
    'accessAddUser',
    'accessAdd',
    'ownerUser',
    'reportUser',
    'filterUser',
    'facePerson',
  ];

  let height = 32;
  if (highLists.includes(selectProps.name)) {
    height = 60;
  }

  const getOptionSize = (option) => {
    if (option && option.options) {
      return options.length * height + 24;
    }

    return height;
  };

  const getItemSize = i => (getOptionSize(options[i]));

  const [value] = getValue();
  const initialOffset = options.indexOf(value) * height;
  const totalHeight = options.reduce((h, o) => (h + getOptionSize(o)), 0) + 20;
  const estimatedItemSize = totalHeight / options.length;

  updateDropdownWidth();

  return (
    <List
      ref={menuListRef}
      height={Math.min(totalHeight, 300)}
      itemCount={nChildren.length}
      itemSize={getItemSize}
      estimatedItemSize={estimatedItemSize}
      initialScrollOffset={initialOffset}
      onItemsRendered={() => {
        updateDropdownWidth();
      }}
    >
      {({ index, style }) => <div style={style}>{nChildren[index]}</div>}
    </List>
  );
};

SelectVirtualMenuList.propTypes = {
  options: PropTypes.array.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  getValue: PropTypes.func.isRequired,
  selectProps: PropTypes.any.isRequired,
};

export default SelectVirtualMenuList;
